<lms-message-create
  (messageCreated)="onMessageCreated($event)"
  [groupId]="group.id"
  [listId]="listId"
></lms-message-create>
<div class="tools">
  <lms-items-count-selector class="hide-on-med-and-down" [listId]="listId"></lms-items-count-selector>
</div>
<lms-list
  [listId]="listId"
  [serviceProvider]="messagesService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="message"
      label="groupMessages.message"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="created_at"
      label="groupMessages.date"
    ></lms-list-header>
  </div>
  <lms-messages-list-row *ngFor="let message of messages" [message]="message" [group]="group"> </lms-messages-list-row>
</lms-list>
